import { render, staticRenderFns } from "./PageAttributes.vue?vue&type=template&id=15e9244a&"
import script from "./PageAttributes.vue?vue&type=script&lang=js&"
export * from "./PageAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e9244a')) {
      api.createRecord('15e9244a', component.options)
    } else {
      api.reload('15e9244a', component.options)
    }
    module.hot.accept("./PageAttributes.vue?vue&type=template&id=15e9244a&", function () {
      api.rerender('15e9244a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attributes/PageAttributes.vue"
export default component.exports